export interface User {
  id: number;
  username: string;
  email: string;
  full_name?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserLogin {
  username: string;
  password: string;
}

export interface Token {
  access_token: string;
  token_type: string;
}

export interface AudioFile {
  path: string;
  caption: string;
}

export interface Article {
  id: number;
  title: string;
  slug: string;
  content: string;
  summary?: string;
  image_path?: string;
  audio_path?: string; // Deprecated - use audio_files
  audio_files?: AudioFile[];
  files?: string[];
  status: ArticleStatus;
  author_id: number;
  author: User;
  created_at: string;
  updated_at: string;
  published_at?: string;
}

export enum ArticleStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export interface ArticleCreate {
  title: string;
  content: string;
  summary?: string;
  status?: ArticleStatus;
  published_at?: string;
}

export interface Album {
  id: number;
  name: string;
  slug: string;
  description?: string;
  cover_image?: string;
  status: AlbumStatus;
  author_id?: number;
  author?: User;
  media_count: number;
  created_at: string;
  updated_at: string;
  published_at?: string;
  date?: string;
  media_items?: AlbumMedia[];
}

export enum AlbumStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  PRIVATE = 'private',
}

export interface AlbumCreate {
  name: string;
  description?: string;
  status?: AlbumStatus;
}

export interface AlbumMedia {
  id: number;
  album_id: number;
  filename: string;
  file_path: string;
  file_type: string;
  mime_type: string;
  file_size: number;
  title?: string;
  description?: string;
  sort_order: number;
  created_at: string;
}

export interface AlbumMediaCreate {
  title?: string;
  description?: string;
  sort_order?: number;
}

export interface Event {
  id: number;
  title: string;
  slug: string;
  description: string;
  image_path?: string;
  files?: string[];
  location?: string;
  event_date: string;
  registration_deadline?: string;
  status: EventStatus;
  author_id: number;
  author: User;
  created_at: string;
  updated_at: string;
  published_at?: string;
}

export enum EventStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  CANCELLED = 'cancelled',
}

export interface EventCreate {
  title: string;
  description: string;
  location?: string;
  event_date: string;
  registration_deadline?: string;
  status?: EventStatus;
}

export interface ApiResponse<T> {
  data: T;
  message?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
}

export interface Canticle {
  id: number;
  title: string;
  slug: string;
  lyrics: string;
  pdf_path?: string;
  status: CanticleStatus;
  author_id: number;
  author: User;
  created_at: string;
  updated_at: string;
  published_at?: string;
}

export enum CanticleStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export interface CanticleCreate {
  title: string;
  lyrics: string;
  pdf_path?: string;
  status?: CanticleStatus;
}

export interface Book {
  id: number;
  edition_num?: string | null;
  title: string;
  author?: string | null;
  description?: string;
  price?: number | null;
  currency: string;
  external_link?: string | null;
  pdf_path?: string | null;
  cover_image?: string;
  year?: number;
  isbn?: string;
  publisher?: string;
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface BookCreate {
  title: string;
  edition_num?: string | null;
  author?: string | null;
  description?: string;
  price?: number | null;
  currency?: string;
  external_link?: string | null;
  pdf_path?: string | null;
  cover_image?: string;
  year?: number;
  isbn?: string;
  publisher?: string;
  is_published?: boolean;
}

export interface Message {
  id: number;
  name: string;
  email: string;
  subject: string;
  message: string;
  is_read: boolean;
  is_archived: boolean;
  created_at: string;
}
